var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIncentive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.024,
    height: 40.024,
    viewBox: "0 0 40.024 40.024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_187494",
    "data-name": "Group 187494",
    transform: "translate(-325.009 -266.26)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37627",
    "data-name": "Path 37627",
    d: "M10.006,0H30.018A10.006,10.006,0,0,1,40.024,10.006V30.018A10.006,10.006,0,0,1,30.018,40.024H10.006A10.006,10.006,0,0,1,0,30.018V10.006A10.006,10.006,0,0,1,10.006,0Z",
    transform: "translate(325.009 266.26)",
    fill: "#fbf2ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_187415",
    "data-name": "Group 187415",
    transform: "translate(334 275.333)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_187416",
    "data-name": "Group 187416",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37629",
    "data-name": "Path 37629",
    d: "M11.974,23.753A11.075,11.075,0,1,1,23.039,34.819,11.092,11.092,0,0,1,11.974,23.753m11.082,9.593a9.6,9.6,0,1,0-9.605-9.605,9.591,9.591,0,0,0,9.605,9.605",
    transform: "translate(-11.236 -11.891)",
    fill: "#61277f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37631",
    "data-name": "Path 37631",
    d: "M146.06,97.942c0-.208,0-.407,0-.606a.737.737,0,1,1,1.474,0c0,.2,0,.4,0,.585.285.1.561.17.816.288a2.174,2.174,0,0,1,1.4,2.02.736.736,0,1,1-1.47.07.813.813,0,0,0-.523-.749,2.2,2.2,0,0,0-1.917.008.935.935,0,0,0-.186,1.572,4.439,4.439,0,0,0,1.016.52c.417.174.858.292,1.274.468a2.673,2.673,0,0,1,1.806,2.629,2.1,2.1,0,0,1-1.156,1.888,10.368,10.368,0,0,1-1.056.441c0,.148,0,.345,0,.543a.739.739,0,1,1-1.475,0c0-.191,0-.382,0-.549a9.817,9.817,0,0,1-1-.4,2.131,2.131,0,0,1-1.212-1.9.737.737,0,0,1,.7-.812.723.723,0,0,1,.773.734.769.769,0,0,0,.436.685,2.164,2.164,0,0,0,2.079,0,.937.937,0,0,0,.134-1.513,3.588,3.588,0,0,0-.9-.491c-.5-.209-1.031-.356-1.53-.571a2.574,2.574,0,0,1-1.646-2.039,2.282,2.282,0,0,1,1.737-2.7c.132-.04.267-.072.43-.116",
    transform: "translate(-134.983 -90.629)",
    fill: "#61277f"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncentive);
export default __webpack_public_path__ + "static/media/incentive.80f33fa01c69214e7e51e389b5a48f3b.svg";
export { ForwardRef as ReactComponent };